import moment from 'moment';
import range from 'lodash/range';
import flatpickr from 'flatpickr';
import MonthPlugin from './month-plugin';


class DayOverrides {
  constructor($scope, $element) {
    'ngInject';

    this.$scope = $scope;
    this.$element = $element;
    const startOfWeek = moment().startOf('isoWeek');
    this.weekLabels = range(0, 7).map(day => ({
      day,
      label: startOfWeek.weekday(day).format('ddd'),
    }));
    this.daysOfWeekHash = {};
  }

  $onChanges(changes) {
    let invalidate = false;
    if (changes.weekDayConfig && changes.weekDayConfig.currentValue) {
      this.daysOfWeekHash = {};
      const now = moment().startOf('isoWeek');
      this.weekDayConfig.forEach((d) => {
        const day = now.day(d.weekDayIndex);
        this.daysOfWeekHash[day.weekday()] = d.isWorking;
      });
      invalidate = true;
    }
    if (changes.dayOverrides && changes.dayOverrides.currentValue) {
      this.dayOverridesHash = {};
      this.dayOverrides.forEach((d) => {
        this.dayOverridesHash[moment(d.day).format('YYYY-MM-DD')] = d.isWorking;
      });
      invalidate = true;
    }
    if (invalidate) {
      this.updateWeeks();
    }
  }

  isWorking(dayOfMonth) {
    const hashKey = dayOfMonth.format('YYYY-MM-DD');
    if (typeof this.dayOverridesHash[hashKey] === 'boolean') {
      return this.dayOverridesHash[hashKey];
    }
    return this.daysOfWeekHash[dayOfMonth.weekday()];
  }

  isWorkingWeekDay(weekDay) {
    return this.daysOfWeekHash[weekDay];
  }

  updateWeeks() {
    const now = this.instance
      ? moment().year(this.instance.currentYear).month(this.instance.currentMonth)
      : moment();
    const startOfMonth = now.startOf('month');
    const dayOffset = startOfMonth.weekday() - 1;
    this.weeks = range(0, 6)
      .map(week => range(0, 7)
        .map((dayOfWeek) => {
          const dayOfMonth = moment(startOfMonth).date((7 * week) + (dayOfWeek - dayOffset));
          return {
            currentMonth: startOfMonth.month() === dayOfMonth.month(),
            week,
            dayOfWeek,
            dayOfMonth,
            dayOfMonthLabel: dayOfMonth.format(ttb.constants.dateTime.DATE_FORMAT),
            isWorking: this.isWorking(dayOfMonth),
            dayOfYear: dayOfMonth.dayOfYear(),
            label: dayOfMonth.format('D'),
          };
        }));

    const currentWeek = (week) => {
      for (let i = 0; i < week.length; i++) {
        if (week[i].currentMonth) {
          return true;
        }
      }
      return false;
    };
    if (!currentWeek(this.weeks[5])) {
      this.weeks.length = 5;
    }
  }

  onDayChange({ dayOfMonth, isWorking }) {
    const hashKey = dayOfMonth.format('YYYY-MM-DD');
    if (this.daysOfWeekHash[dayOfMonth.weekday()] === isWorking) {
      delete this.dayOverridesHash[hashKey];
    } else {
      this.dayOverridesHash[hashKey] = isWorking;
    }
    this.dayOverrides.splice(0, this.dayOverrides.length);
    this.dayOverrides.push(...Object.keys(this.dayOverridesHash).map(key => ({
      day: key,
      isWorking: this.dayOverridesHash[key],
    })));
    if (this.onChange) {
      this.onChange();
    }
  }

  $postLink() {
    const onChange = () => {
      this.$scope.$apply(() => {
        this.updateWeeks();
      });
    };
    this.instance = flatpickr(this.$element[0].querySelector('.month-picker'), {
      inline: true,
      plugins: [new MonthPlugin()],
      onMonthChange: onChange,
      onYearChange: onChange,
    });
  }

  $onDestroy() {
    this.instance.destroy();
  }
}


export default DayOverrides;



// WEBPACK FOOTER //
// ../widgets/day-overrides/day-overrides.controller.js